import { render } from "./FinanceBlock.vue?vue&type=template&id=4f6f307e"
import script from "./FinanceBlock.vue?vue&type=script&lang=js"
export * from "./FinanceBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__